export const AVATAR_GRADIENTS = [
    { from: '#14B8A6', to: '#0D9488' },   // teal
    { from: '#6366F1', to: '#4F46E5' },   // indigo
    { from: '#F59E0B', to: '#D97706' },   // amber
    { from: '#EC4899', to: '#DB2777' },   // pink
    { from: '#10B981', to: '#059669' },   // emerald
    { from: '#8B5CF6', to: '#7C3AED' },   // violet
];

function hashCode(str) {
    let h = 0;
    for (let i = 0; i < str.length; i += 1) {
        h = ((h << 5) - h) + str.charCodeAt(i);
        h |= 0;
    }
    return Math.abs(h);
}

export function avatarGradient(uid) {
    const key = uid ? String(uid) : 'default';
    const idx = hashCode(key) % AVATAR_GRADIENTS.length;
    return AVATAR_GRADIENTS[idx];
}

export function monogram(name, email) {
    const cleanName = (name || '').trim();
    if (cleanName) {
        const parts = cleanName.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return parts[0].slice(0, 2).toUpperCase();
    }
    const local = (email || '').split('@')[0];
    if (local) {
        const segs = local.split(/[._-]+/).filter(Boolean);
        if (segs.length >= 2) {
            return (segs[0][0] + segs[1][0]).toUpperCase();
        }
        return local.slice(0, 2).toUpperCase();
    }
    return '?';
}
